import * as React from "react";
import { loader } from "graphql.macro";
import {
  PackOffersQuery,
  PackOffersQueryVariables,
} from "../../Shop/graphql/PackOffersQuery.generated";
import { useQuery } from "../../../hooks/useQuery";
import { useShop } from "../../Shop";
import { useNotificationsPanel } from "../index";

const PACK_OFFERS_QUERY = loader("../../Shop/graphql/PackOffersQuery.graphql");

/**
 * Looks up a personal pack offer of the player. `open` is null while the offer is unknown, used or expired;
 * otherwise it closes the notifications panel and opens the shop tab where the offer is shown first.
 */
export const usePackOffer = (offerId: string, setRead: () => void) => {
  const openShop = useShop();
  const openNotifications = useNotificationsPanel();
  const [{ data, fetching }] = useQuery<
    PackOffersQuery,
    PackOffersQueryVariables
  >({
    query: PACK_OFFERS_QUERY,
    //The offer may have been created after the list was cached
    requestPolicy: "cache-and-network",
    //A failed lookup must not break the whole notifications list
    throwOnError: false,
  });

  //Only offers that are still active come back, so a used or expired one is simply not found
  const offer =
    data?.packOffers?.find(
      (o) => o.id === offerId && new Date(o.expires) > new Date()
    ) ?? null;

  const open = React.useMemo(() => {
    if (offer === null) return null;

    return () => {
      setRead();
      openNotifications(false);
      openShop(offer.chipPack.primary.currency);
    };
  }, [offer, setRead, openNotifications, openShop]);

  return { open, fetching };
};
